<template>
	<section
		class="thank-you-container margin-top-perc flex items-center flex-col will-change"
		:data-scroll-section="inner == 'false'"
	>
		<div
			class="flex flex-col items-center text-center will-change thank-you-borderd"
			data-scroll
			data-scroll-class="xyz-in"
			xyz="fade down duration-15"
		>
			<img
				class="thankyou__img"
				v-show="blockData.image"
				:src="blockData.image.url"
				:alt="blockData.image.alt"
			/>
			<h2 class="text-5xl  xl:text-heading mb-8" v-show="blockData.title">
				{{ blockData.title }}
			</h2>
			<div
				class="max-60vw text-l leading-normal mb-8"
				v-show="blockData.text"
				v-html="blockData.text"
			></div>
			<div class="go-to-home-btn-container">
				<a href="https://lusticabay.com/" role="button" class="go-to-home-btn"
					>GO BACK TO HOME PAGE</a
				>
			</div>
		</div>
	</section>
</template>

<script>
export default {
	name: "ThankYou",
	data() {
		return {};
	},
	mounted() {},
	methods: {}
};
</script>

<style scoped>
.thank-you-borderd {
	box-shadow: 0px 0px 2px 0px rgb(0 0 0 / 50%);
	padding: 3.125rem 1.125rem;
}
.thank-you-container {
	width: calc(100% - 8vw);
}
.thankyou__img {
	margin-bottom: 1rem;
}
.margin-top-perc {
	margin: 24% auto 14%;
}
.text-5xl {
	font-size: 3rem;
}
.text-l {
	font-size: 1.1rem;
	font-weight: 400;
}
.go-to-home-btn-container {
	padding: 1rem 0;
}
.go-to-home-btn {
	font-weight: 100;
	font-size: 0.85rem;
	text-shadow: 0px 0px 10px rgb(0 0 0 / 30%);
	background-color: #001e31;
	width: fit-content;
	padding: 1rem 1.5rem;
	color: white;
}
@media (min-width: 768px) {
	.thank-you-borderd {
		box-shadow: 0px 0px 2px 0px rgb(0 0 0 / 50%);
		padding: 3.125rem;
	}
	.thank-you-container {
		width: calc(100%-4vw);
	}
	.margin-top-perc {
		margin: 14% auto;
	}
}
@media (min-width: 1280px) {
	.xl\:pt-56 {
		padding-top: 14rem;
	}
	.max-60vw {
		max-width: 60vw;
	}
}
</style>
